// mux-player is ~1MB of JavaScript, and it was loaded on every page of the
// site — collection pages, the cart, account pages — whether or not anything
// on them was a video.
//
// Load it only once a <mux-player> is actually near the viewport. Until then
// the element renders nothing, which is why every render site paints the Mux
// poster as its own background: the still frame is visible from first paint,
// with no JS involved, and the player draws over it when it upgrades.
//
// Deferring the upgrade also defers playback, so a video the visitor never
// scrolled to is never fetched from Mux — that traffic is billed.
(function () {
	const SRC = 'https://cdn.jsdelivr.net/npm/@mux/mux-player';
	// Start loading before the video is on screen; the poster covers the gap.
	const ROOT_MARGIN = '400px';

	let requested = false;

	function loadPlayer() {
		if (requested) return;
		requested = true;
		const script = document.createElement('script');
		script.src = SRC;
		document.head.appendChild(script);
	}

	// One observer for the whole document: the first player to come into range
	// pulls in the script, which upgrades every other player on the page too.
	const observer =
		'IntersectionObserver' in window
			? new IntersectionObserver(
					(entries) => {
						for (const entry of entries) {
							if (entry.isIntersecting) {
								loadPlayer();
								observer.disconnect();
								return;
							}
						}
					},
					{ rootMargin: ROOT_MARGIN }
				)
			: null;

	function watch(root) {
		if (requested) return;
		const players = (root || document).querySelectorAll('mux-player');
		if (!players.length) return;
		// No IntersectionObserver: load it rather than leave the visitor with a
		// poster that never becomes a video.
		if (!observer) return loadPlayer();
		players.forEach((player) => observer.observe(player));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => watch());
	} else {
		watch();
	}

	// Players can arrive after load — pdp-recommendations fetches its section,
	// and the favorites drawer renders on open.
	if ('MutationObserver' in window) {
		new MutationObserver((records) => {
			if (requested) return;
			for (const record of records) {
				for (const node of record.addedNodes) {
					if (node.nodeType !== 1) continue;
					if (node.tagName === 'MUX-PLAYER') watch(node.parentNode);
					else if (node.querySelector && node.querySelector('mux-player')) watch(node);
				}
			}
		}).observe(document.documentElement, { childList: true, subtree: true });
	}
})();
